/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "PharaonAmicareAlarms",
            "endpoint": "https://5zdnmol287.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        },
        {
            "name": "PharaonAmicareEnvironmentsApi",
            "endpoint": "https://dmiu2mpgz2.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        },
        {
            "name": "PharaonAmicareEventsApi",
            "endpoint": "https://h6eg4ddjnc.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        },
        {
            "name": "PharaonAmicareFridgeApi",
            "endpoint": "https://lgbj0aqkjh.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        },
        {
            "name": "PharaonAmicareUsersApi",
            "endpoint": "https://9xwu0yyf94.execute-api.eu-central-1.amazonaws.com/staging",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:37a8637a-e066-461b-b00d-b0ddbbebf78f",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_Q9SsWv679",
    "aws_user_pools_web_client_id": "2fsc8hrujm0i8lkmhl34i1o1di",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "pharaonamicare2apk121350-staging",
    "aws_user_files_s3_bucket_region": "eu-central-1",
    "aws_dynamodb_all_tables_region": "eu-central-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "PharaonAmicareAlarms-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "PharaonAmicareEnvironments-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "PharaonAmicareEnvironmentsv2-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "PharaonAmicareEvents-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "PharaonAmicareEventsv2-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "PharaonAmicareFridge-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "PharaonAmicareUsers-staging",
            "region": "eu-central-1"
        },
        {
            "tableName": "PharaonAmicareVersionApp-staging",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_login_mechanisms": [
        "PREFERRED_USERNAME"
    ]
};


export default awsmobile;
